import { KeyboardArrowRight } from "@ellaandil/ui";
import { StoryblokComponent } from "@trydig/storyblok";
import { useHeader } from "@/features/navigation/Header/components/HeaderProvider";

export interface MainMenuViewProps {
	onSectionSelect: (title: string) => void;
	preview: boolean;
}

export const MainMenuView = ({ onSectionSelect, preview }: MainMenuViewProps) => {
	const { content } = useHeader();
	return (
		<>
			{content?.map((section) => {
				if (section.component === "link") {
					return (
						<StoryblokComponent
							key={section._uid}
							blok={section}
							preview={preview}
							className="font-display py-1.5 leading-[125%] text-2xl"
						/>
					);
				}

				if (section.component === "megaMenu" && section.title) {
					return (
						<button
							key={section._uid}
							className="font-display py-1.5 leading-[125%] text-2xl flex items-center justify-between"
							type="button"
							onClick={() => onSectionSelect(section.title!)}
						>
							<span>{section.title}</span>
							<KeyboardArrowRight width={24} height={24} />
						</button>
					);
				}

				return null;
			})}
		</>
	);
};
